/**
 * Sysnet API
 *  ## Authorization We use bearer auth throughout the API. Generally, API requests should have the follow header:   {       \"content-type\": \"application/json\",       \"Authorization\": \"Bearer TOKEN_GOES_HERE\"   }   Please refer to the Auth section immediately below for details on getting your token.
 *
 * OpenAPI spec version: 1.0.4
 * Contact: support@hlpos.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CreateDateTime } from './createDateTime';
import { ExternalKey } from './externalKey';
import { ExternalKeys } from './externalKeys';
import { LastUpdateByUserId } from './lastUpdateByUserId';
import { UpdateDateTime } from './updateDateTime';

/**
 * Factors describe all the various ways stock can be moved or sold.  Example: Whiskey  is purchased by the case or dozen but  sold by the single bottle, 30ml nip and 15ml nip
 */
export interface FactorView { 
    /**
     * The unique identifier of this record.
     */
    factorId?: number;
    /**
     * A reference to the primary key in the Stock Table
     */
    stockId?: number;
    divider?: number;
    alhStockCode?: string;
    /**
     * A reference to the primary key in the Containers Table
     */
    containerId?: number;
    volumeDivider?: number;
    pourTime?: number;
    promptForSerial?: boolean;
    createDateTime?: CreateDateTime;
    updateDateTime?: UpdateDateTime;
    lastUpdateByUserId?: LastUpdateByUserId;
    externalKeys?: ExternalKeys;
    externalKey?: ExternalKey;
    status?: FactorView.StatusEnum;
    /**
     * Calculated field - Stock.innersPerOuter / divider
     */
    innerQty?: number;
    /**
     * Calculated field - divider
     */
    usageDividerNumberInOuters?: number;
    /**
     * Calculated field - Stock.innersPerOuter / divider
     */
    usageDividerNumberOfInners?: number;
    /**
     * Calculated field - Stock.mls / divider
     */
    usageDividerUnitSize?: number;
    /**
     * Calculated field - volumeDivider
     */
    volumeDividerNumberInOuters?: number;
    /**
     * Calculated field - Stock.innersPerOuter / volumeDivider
     */
    volumeDividerNumberOfInners?: number;
    /**
     * Calculated field - Stock.mls / volumeDivider
     */
    volumeDividerUnitSize?: number;
}
export namespace FactorView {
    export type StatusEnum = 'active' | 'disabled';
    export const StatusEnum = {
        Active: 'active' as StatusEnum,
        Disabled: 'disabled' as StatusEnum
    };
}